export default __webpack_public_path__ + "alberta-text.a117388163be8dbb71c7.svg";